import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/mobile/lib/sendAnalyticsEvent/index';

import {GENERAL_HEADER_BUTTON} from 'constants/analytics/events/general';

/**
 * mini cart drawer event for several cases
 */
export const miniCartDrawerEvent = (eventLabel: string) =>
    sendDesktopAnalyticsEvent(GENERAL_HEADER_BUTTON, {
        buttonName: 'Mini Cart',
        label: eventLabel,
    });
